import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import EstimatedUnbillFigureContMain from "presentation/view/container/EstimatedUnbillFigure/EstimatedUnbillFigureContMain";

CommonEntrypoint(<EstimatedUnbillFigureContMain />)